import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/map';
import { Http } from '@angular/http';

@Injectable()
export class GeneralSettingsService {
    constructor (private http: Http, private authHttp: AuthHttp){}

    getBeginEndCalendarDates(){
        return this.http.get('/api/general/calenderdates').map(res => res.json());
    }

    setBeginEndCalendarDates(settings:any){
        return this.authHttp.post('/api/general/calenderdates',settings).map(res => res.status);
    }
    
    setNewSubscriptionNotifyEmail(email: string, toName: string){
        var settings = {
            NewSubscriptionNotifyEmail: email,
            NewSubscriptionNotifyToName:  toName
        }
        return this.authHttp.post('/api/general/NewSubscriptionNotifyEmail', settings).map(res => res.status)
    }

    getNewSubscriptionNotifyEmail(){
        return this.authHttp.get('/api/general/getSubscriptionNotifyEmail').map(res => res.json())
    }

    getNewSubscriptionNotifyToName(){
        return this.authHttp.get('/api/general/getSubscriptionNotifyToName').map(res => res.json())
    }

    getGeneralInformation(){
        return this.authHttp.get('/api/general/getGeneralInformation').map(res => res.json())
    }

    setGeneralInformation(generalSettings:any){
        return this.authHttp.post('/api/general/setGeneralInformation',generalSettings).map((res:any)=>{
            return { 'status': res.status, 'value': '' }
        })
    }

    getSubscriptionFee(){
        return this.authHttp.get('/api/general/getSubscriptionFee').map( (res:any)=>{
            let value = "";
            if (res.status == 200){
                value = res.json()
            }
            return {'status':res.status, 'value': value}
        })
    }

    setSubscriptionFee(amount: string){
        return this.authHttp.put('/api/general/setSubscriptionFee/'+amount,null).map( (res:any)=>{
            let value = "";
            if (res.status == 200){
                value = res.json()
            }
            return {'status':res.status, 'value': value}
        })
    }

    getBankAccount(){
        return this.authHttp.get('/api/general/getBankAccount/').map( (res:any)=>{
            let value = "";
            if (res.status == 200){
                value = res.json()
            }
            return {'status':res.status, 'value': value}
        })
    }

    getGeneralEmail(){
        return this.authHttp.get('/api/general/getGeneralEmail/').map( (res:any)=>{
            let value = "";
            if (res.status == 200){
                value = res.json()
            }
            return {'status':res.status, 'value': value}
        })
    }

    setHealthInsurancePaperCheck(status: boolean){
        return this.authHttp.put("/api/general/setHealthInsurancePaperActive/"+status,null).map ( (res:any)=>{
            let value=""
            if (res.status == 200){
                value=res.json()
            }
            return {'status':res.status, 'value': value}
        } )
    }

    getHealthInsurancePaperCheck(){
        return this.authHttp.get("/api/general/getHealthInsurancePaperActive").map ( (res:any)=>{
            let value=""
            if (res.status == 200){
                value=res.json()
            }
            return {'status':res.status, 'value': value}
        } )
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/general-settings.service.ts